import { render, staticRenderFns } from "./CommissionDataTable.vue?vue&type=template&id=3797f61e&scoped=true&"
import script from "./CommissionDataTable.vue?vue&type=script&lang=js&"
export * from "./CommissionDataTable.vue?vue&type=script&lang=js&"
import style0 from "./CommissionDataTable.vue?vue&type=style&index=0&id=3797f61e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3797f61e",
  null
  
)

export default component.exports